/* eslint-disable no-unused-vars */
const cognitoConfig = {
    REGION: window.joint_customers?.region,
    USER_POOL_ID: window.joint_customers?.user_pool_id,
    APP_CLIENT_ID: window.joint_customers?.app_client_id,
    DOMAIN: window.joint_customers?.domain,
};

export default cognitoConfig;
